import { render, staticRenderFns } from "./appointments-page.vue?vue&type=template&id=439d2ecc"
import script from "./appointments-page.vue?vue&type=script&lang=js"
export * from "./appointments-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports